const constants = {
  ENDPOINT_SALES: `${process.env.REACT_APP_BACKEND_URL}`,
};

export default constants;
